var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteConfirmationModal',{attrs:{"additionalText":_vm.additionalText,"bodyText":_vm.bodyText,"cancelText":"cancel","confirmationInputConfig":_vm.confirmationInputConfig,"continueText":"delete","handleCancel":_vm.hideModal,"handleContinue":_vm.action,"headerText":_vm.headerText,"mainActionAttention":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }